import axios from 'axios'

// export let baseURL = 'http://192.168.1.96:8080'
export let baseURL = 'https://xc-os-api.din-job.com'
export let defaultPlatformUrl = ''

const request = axios.create({
  baseURL,
  timeout: 10 * 1000
})

request.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
)

export default request
